import React from 'react'
import Grid from "@mui/material/Grid"
import LayoutBox from "../../global/LayoutBox"
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import {useSelector} from 'react-redux'
import {Link} from "react-router-dom";

function Faqs() {

    const user = useSelector(state => state.global.user)

    return (
        <>
            <Grid container>
                <LayoutBox>
                    <Grid container>
                        <Grid item xs={12}>
                            <Box sx={{maxWidth: '1024px', mx: 'auto'}}>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>Where can I find more classes?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>The four classes on your dashboard are this week's new classes for whichever
                                            training program you have selected.
                                            There are over 500 classes in <Link to='/search?q=Pole'>Pole</Link>, <Link
                                                to='/search?q=Floor'>Floor</Link>, and <Link
                                                to='/search?q=Aerial'>Aerial</Link>.
                                            These can all be found in your Class Search.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>What is a Technique?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>A technique is a particular move or series of movements
                                            taught in a class. When you don’t have time to take a
                                            whole class, or just want to focus on something specific
                                            you can search for that technique.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>Can I upgrade to an annual membership?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {user.authenticated ?
                                            <p>Yes, of course. Your account will be prorated to take into account any
                                                time
                                                you have remaining on your current subscription period.</p>
                                            :
                                            <p>Yes, of course. Your account will be prorated to take into account any
                                                time
                                                you have remaining on your current subscription period.</p>
                                        }

                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>What is included in the training programs?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>The pole training programs include 2 pole classes, 1 core class, and 1 flex
                                            class. The floor training program includes 2 flex classes and 2 core
                                            classes.
                                            The aerial training program includes 1 aerial class, 1 flex class, and 2
                                            core
                                            classes.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>Why do you have training programs?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>We have designed these training programs so you can maintain a balanced
                                            training
                                            schedule to ensure your future success. Feel free to follow the programs or
                                            simply take the classes that work for you.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>How long are the classes?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>Each class varies in length depending on the material covered, but typically
                                            the
                                            classes are between 30 - 40 minutes.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>How many classes can I take?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>There is no limit to the amount of times you can take any class or how many
                                            classes you take, and all of the training programs are included in your
                                            subscription.</p>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>How can I book a live class?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>Visit our <Link to='/live'>Live</Link> page, and when classes are available
                                            there
                                            will be a Sign Up button present. Press this button and fill
                                            our the short form on the sign up page and you are all
                                            set.</p>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>When are live classes offered?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>Live classes are typically offered once a week. The day
                                            and time is dependent on instructors schedule.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>When does registration open for live classes?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>Registration opens up 48 hours in advance of the class.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>I missed a live class -- is there a recording available?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>Yes, most classes are available in our <Link to='/dashboard/live'>Live
                                            Archive</Link>, with few exceptions.</p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>When is the site updated?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>The site is updated weekly, on Tuesday by the end of the business day
                                            EST.</p>
                                    </AccordionDetails>
                                </Accordion>
                                {
                                    user.authenticated &&
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                            <h5>How do I cancel my subscription?</h5>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <p>Login to your account, click on the subscriptions tab, next to
                                                Subscription :: choose “cancel subscription”. You'll receive an email
                                                confirmation that cancellation was successful. Once you cancel your
                                                account you will retain access to B&P Online until your current
                                                subscription period ends. You can, of course, rejoin anytime in the
                                                future. Please cancel your account BEFORE your next payment is due. It
                                                is best to cancel at least 24 hours in advance to ensure you are not
                                                charged due to time differences. You will retain access to B&P Online
                                                until your next payment is due, so you can cancel as far in advance as
                                                you would like. Please let us know if you have any questions.</p>
                                        </AccordionDetails>
                                    </Accordion>
                                }
                                {
                                    user.authenticated &&
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                            <h5>My Payment failed, what can I do?</h5>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <p>If you know that your card details have changed then you
                                                can go to your <Link to='/account'>Account</Link> page select the <Link
                                                    to='/subscriptions'>Subscriptions</Link> tab
                                                and choose “update”. Once you change your card details
                                                your payment will be processed immediately. If your
                                                subscription is canceled due to failed payments, you will
                                                need to sign up with a new subscription if you would like
                                                to regain access to B&P Online.
                                                Please contact us if you have any further questions about
                                                failed payments.</p>
                                        </AccordionDetails>
                                    </Accordion>
                                }
                                {
                                    user.authenticated &&
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                            <h5>I am receiving an error message saying I do not have access to this
                                                content?</h5>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <p>Please go to your <Link to='/account'>Account</Link> page, select the <Link
                                                to='/subscriptions'>Subscriptions</Link> tab and check
                                                that your membership subscription is showing as active. If your
                                                subscription is current then please try logging out of your account,
                                                clearing your browser cache and then logging back in again. If this does
                                                not fix the issue please contact us and let us know what page you are
                                                receiving this error for.</p>
                                            <p>Please go to your <Link to='/account'>Account</Link> page select
                                                the <Link
                                                    to='/subscriptions'>Subscriptions</Link>
                                                tab and check that your membership subscription is
                                                showing as active. If your subscription is current then
                                                please try logging out of your account, clearing your
                                                browser cache and then logging back in again. If this
                                                does not fix the issue please contact us and let us know
                                                what page you are receiving this error for.</p>
                                        </AccordionDetails>
                                    </Accordion>
                                }
                                {
                                    !user.authenticated &&
                                    <Accordion>
                                        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                            <h5>How much is a subscription?</h5>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <p>The standard plan is $19.99 per month, and our yearly
                                                plan is $199 per year. Please see our <Link
                                                    to='/pricing'>Pricing</Link> page for
                                                more info. All subscriptions are renewed automatically
                                                until canceled.</p>
                                        </AccordionDetails>
                                    </Accordion>
                                }
                                <Accordion>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                        <h5>What is your refund policy?</h5>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>B&P Online offers a free trial to all users to try us out. If
                                            at any time you’re not satisfied within the trial period,
                                            you can cancel your account before your trial ends and
                                            you will not be charged. Unless your account is canceled,
                                            you will begin to be billed automatically. Once we begin
                                            to bill you, cancellations take effect starting at the end of
                                            your current billing period, meaning there are no partial
                                            month refunds or credits. In general, once an account is
                                            past the free trial or billing period, the user is responsible
                                            for all subscription fees. Still, have questions? Contact us
                                            and we’ll get back to you shortly. If you fund a payment
                                            by debit card and your transaction results in an overdraft
                                            or other fees from your bank, you alone are responsible
                                            for that fee. Paused Subscriptions: In circumstances in
                                            which you have elected to pause your subscription, your
                                            account will automatically reactivate following the time
                                            period you specified at the time of pausing, and we will
                                            automatically bill you. You are responsible for such
                                            payment regardless of whether or not you received a
                                            reminder notice regarding the expiration of your paused
                                            status. By electing to pause your subscription, you
                                            agreed and authorized B&P Online to bill your account at
                                            the expiration of your paused account period.</p>
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        </Grid>
                    </Grid>
                </LayoutBox>
            </Grid>
        </>
    )
}

export default Faqs